import { takeLatest } from "redux-saga/effects";
import { getSettingsSaga } from "./sagas/getSettingsSaga";
import { saveSmtpSettingsSaga } from "./sagas/saveSmtpSettingsSaga";
import { getSmtpConfigs, saveSmtpConfigs } from "./settingsActions";

export function* settingsSaga() {
  yield takeLatest(getSmtpConfigs.type, getSettingsSaga);
  yield takeLatest(saveSmtpConfigs.type, saveSmtpSettingsSaga);
}
